import { useState } from 'react';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { SaveClientFlags } from '@sdk/authentication/types';

import PopupSurveyContainer from '@web/components/survey/PopupSurveyContainer';
import SurveyCloseButton from '@web/components/survey/SurveyCloseButton';
import HappinessSurveySteps from '@web/components/happinessSurvey/HappinessSurveySteps';
import { useHappinessSurvey } from '@web/components/happinessSurvey/HappinessSurvey.hooks';

type Props = {
  user: AuthUserType;
  locationsCount: number;
  usersCount: number;
  saveClientFlags: SaveClientFlags;
  onScheduleTab: boolean;
  areShiftsPublished: boolean;
  forceDisplay: boolean;
  onClose?: VoidFunction;
};

const HappinessSurvey = ({
  user,
  locationsCount,
  usersCount,
  saveClientFlags,
  areShiftsPublished,
  onScheduleTab,
  forceDisplay,
  onClose,
}: Props) => {
  const [score, setScore] = useState<number | null>(null);
  const [comment, setComment] = useState('');

  const { closeModal, setSubmitted, isVisible } = useHappinessSurvey(
    user,
    locationsCount,
    usersCount,
    saveClientFlags,
    areShiftsPublished,
    score,
    comment,
    onScheduleTab,
    forceDisplay,
    onClose
  );

  if (!isVisible) {
    return null;
  }

  return (
    <PopupSurveyContainer>
      <SurveyCloseButton onClose={closeModal} />
      <HappinessSurveySteps
        score={score}
        setScore={setScore}
        comment={comment}
        setComment={setComment}
        submitForm={() => setSubmitted(true)}
        closeSurvey={closeModal}
      />
    </PopupSurveyContainer>
  );
};

export default HappinessSurvey;
